import React, { useState, useEffect } from "react";

import Form from "@Components/Form";
import eightAxios from "configs/axiosConfig";
import { GLOBAL_CONFIGURATION_URL } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import SaveIcon from "@material-ui/icons/Save";
import { useNotifyContext } from "@Components/Notify";

const detailURL = "/configuration/get-config/";

const FileUploadSetting = () => {
  const [loading, setLoading] = useState(false);
  const [fileSize, setFileSize] = useState(0);
  const setNotify = useNotifyContext();

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.max_file_upload_size) {
            setFileSize(response.data.max_file_upload_size);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };
  const initialValues = { max_file_upload_size: fileSize };

  useEffect(() => {
    fetchDetails();
  }, []);

  const formFields = [
    {
      name: "max_file_upload_size",
      type: "input",
      label: "Max. File Upload Size (in MB)",
      color: "primary",
      required: true,
      size: "medium",
      value: fileSize,
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Save",
      color: "primary",
      startIcon: <SaveIcon />,
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  const handleSubmit = (values, { setSubmitting }) => {
    eightAxios
      .post(GLOBAL_CONFIGURATION_URL, values)
      .then(() => {
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        fetchDetails();

      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
      })
      .finally(() => {
        window.location.reload();

        setSubmitting(false); 

      });

  };
  return (
    <Form
      initialValues={initialValues}
      outerSubmitHandler={handleSubmit}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Upload File Size Setting"
    />
  );
};

export default FileUploadSetting;
